import { SVGInterface } from "../../interface";

const Phone = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M8.74214 8.68189C7.66901 9.59373 7.27576 11.2567 8.20237 12.5908C9.06948 13.8392 10.1618 14.9313 11.4099 15.798C12.7441 16.7244 14.407 16.3311 15.3187 15.2579L15.3289 15.2626C16.4934 15.8021 17.7304 16.1718 19 16.3603V19L18.9989 19L18.9961 19C11.0215 19.0113 4.99148 12.9111 5.00001 5.00359V5H7.63937L7.63954 5.00117C7.828 6.27065 8.19761 7.50654 8.73714 8.67108L8.74214 8.68189ZM18.9989 21H20C20.5523 21 21 20.5523 21 20V15.4977C21 15.0021 20.637 14.5813 20.1468 14.5086L19.2926 14.3818C18.2123 14.2215 17.1605 13.9069 16.1695 13.4478L15.4166 13.0991C14.9804 12.897 14.462 13.034 14.1826 13.4253L13.8418 13.9024C13.5431 14.3206 12.9728 14.4484 12.5506 14.1552C11.4984 13.4245 10.5761 12.5024 9.84502 11.4499C9.55181 11.0277 9.67955 10.4574 10.0978 10.1587L10.5748 9.81807C10.9661 9.53861 11.1031 9.02021 10.901 8.5839L10.5518 7.83033C10.0927 6.8394 9.77823 5.78774 9.61786 4.70749L9.49104 3.85316C9.41827 3.36296 8.99745 3 8.50188 3H4.00001C3.44773 3 3.00001 3.44772 3.00001 4V5.00143C2.99029 14.0079 9.91023 21.0129 18.9989 21Z"
      fill={color || "#0E171F"}
    />
  </svg>
);

export default Phone;
